#import "../fragments/sms-drip-edition-fragment.graphql"

query GetSmsDripEdition($editionId: ID!) {
    smsDripEdition(id: $editionId) {
        ...SmsDripEditionFragment
    }
}
